import type { BaseDockProfile } from '../../shared/capabilities/base-command/profile'

/**
 * @file cmd.ts
 * @description Telink_Base 底座私有命令表和 HID report 配置，只供 Telink 底座设备装配 profile 使用。
 */

/**
 * Telink_Base 底座协议命令表。
 *
 * 主要覆盖 P5/P6 类无屏底座。
 */
export const CMD_TELINK_BASE = {
  return_factory_settings: [0xb2],
  get_work_mode: [0xa2],
  get_firmware: [0xa1],
  read_eeprom: [0xa4],
  write_eeprom: [0xa5],
  factory_update: [0xa8],
  set_light_effect: [0xc0],
  get_light_effect: [0xc1],
  set_screen_light_effect: [0xf0],
  get_screen_light_effect: [0xf1],
  switch_light: [0xd0],
  set_current_light_effect: [0xc2],
  get_current_light_effect: [0xc3],
  set_current_screen_light_effect: [0xf2],
  get_current_screen_light_effect: [0xf3],
  set_gradient_light_effect: [0xc4],
  get_gradient_light_effect: [0xc5],
} as const

/** Telink_Base 使用的 HID report / ACK 配置。 */
export const TELINK_BASE_PROTOCOL_CONFIG = {
  // 底座命令使用独立 Output Report，避免与标准 HID 输入混用。
  reportId: 0xba,
  featureReportId: 0x08,
  busyAck: 0x02,
  okAck: 0x01,
} as const

export const TELINK_BASE_PROFILE: BaseDockProfile = {
  name: 'Telink_Base',
  config: TELINK_BASE_PROTOCOL_CONFIG,
  commands: CMD_TELINK_BASE,
  childReportOffset: 0,
}

export type TelinkBaseCommand = (typeof CMD_TELINK_BASE)[keyof typeof CMD_TELINK_BASE]
